import ContentLoader from './container'

export default ContentLoader
